var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 396,
    viewBox: "0 0 500 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 0L500.281 396H-0.281311L250 0Z",
    fill: "url(#paint0_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.609 111.983C180.081 110.596 181.836 110.17 182.891 111.188L472.655 390.841C474.597 392.715 473.27 396 470.572 396H87.189C85.134 396 83.687 393.98 84.349 392.034L179.609 111.983Z",
    fill: "url(#paint1_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.214 206.895C277.553 205.262 280.116 205.488 281.149 207.33L384.493 391.532C385.615 393.532 384.17 396 381.877 396H127.343C124.81 396 123.417 393.055 125.025 391.097L276.214 206.895Z",
    fill: "url(#paint2_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.608 280.274C217.781 277.951 220.42 276.703 222.326 278.043L382.248 390.546C384.644 392.232 383.451 396 380.522 396H212.231C210.487 396 209.11 394.517 209.24 392.777L217.608 280.274Z",
    fill: "url(#paint3_linear_4_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_2",
    x1: 250,
    y1: 0,
    x2: 250,
    y2: 528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90A4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_2",
    x1: 181.5,
    y1: 109,
    x2: 280.5,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90A4AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_2",
    x1: 254,
    y1: 203.5,
    x2: 254,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_2",
    x1: 219.5,
    y1: 282.5,
    x2: 299.5,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 396,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconDark);
export default __webpack_public_path__ + "static/media/logo-icon-dark.77d4e15a76a9f3305599166dd60d7a50.svg";
export { ForwardRef as ReactComponent };